module.exports = __webpack_public_path__ + "img/25.4.NH3-N.5905351a.png";